module.exports = __webpack_public_path__ + "img/20190713124150408.ae30900b.png";